<template>
  <article class="relative pt-38">
    <div @click="setRoute('projects')" class="flex absolute top-22.5 left-4.5">
      <svg class="mr-5 transform rotate-90 w-3" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 6L7 12L13 6" stroke="#323749" stroke-linejoin="round"/>
        <path d="M6.99998 0V12" stroke="#323749" stroke-linejoin="round"/>
      </svg>
      <p class="uppercase font-medium fz-10" style="letter-spacing: 0.1rem; color:rgba(110, 117, 141, 1) ">{{ text.projects }}</p>
    </div>
    <section class="content first-part px-4.5">
      <h1 style="color: #f22959; line-height: 1.33;" class="font-light fz-30 mb-12.5">{{text.name}}</h1>

      <hr class="h-px w-full" style="border-color:rgba(151, 163, 203, 0.3);">
      <section class="py-7.5">
        <span class="uppercase font-medium fz-10 mb-2.5" style="color: #6e758d;line-height: 2;">{{text.taskTitle}}</span>
        <p class="lowercase font-medium fz-16" style="line-height: 1.5;">{{text.title}}</p>
      </section>
      <hr class="h-px w-full" style="border-color:rgba(151, 163, 203, 0.3);">
      <section class="py-7.5">
        <span class="uppercase font-medium fz-10 mb-2.5" style="color: #6e758d;line-height: 2;">{{text.realizationTimeTitle}}</span>
        <p class="lowercase  fz-50" style="line-height: 1;">{{text.realizationTime}}</p>
      </section>
      <hr class="h-px w-full mb-12.5" style="border-color:rgba(151, 163, 203, 0.3);">
      <p class="font-medium fz-16 " style="line-height: 1.875;">{{text.text[0]}}</p>
    </section>

    <img :src="require('@/assets/images/projects/' + this.projectId + '/first-m.png')" class="my-25 w-full" alt="">

    <section class="content second-part px-4.5 mb-25">
      <p class="fz-22 mb-12.5" style="color: #f22959; line-height: 1.3636;">{{text.problemsTitle}}</p>

      <div class="flex flex-col">
        <hr class="h-px w-full" style="border-color:rgba(151, 163, 203, 0.3);">
        <div class="flex flex-col mt-7.5" v-for="(item, index) in text.problems" :key="index">
          <span class="uppercase font-medium fz-10 mb-2.5" style="letter-spacing: 0.1rem; color:rgba(110, 117, 141, 1) ">0{{ index + 1 }}</span>
          <p class="font-medium fz-16 w-90p mb-7.5" style="line-height: 1.875;">{{item}}</p>
          <hr class="h-px w-full" style="border-color:rgba(151, 163, 203, 0.3);">
        </div>
      </div>
    </section>

    <slider
        :slides-container-classes="'pl-4.5 mb-7.75 gap-5'"
        :slider-classes="''"
        :similar-slides="true"
        :pagination="true"
        pagination-container-classes="gap-5 pl-4.5"
    >
      <template v-slot:slides>
        <div
            class="slider-slide w-80 flex flex-col"
            v-for="item in text.images"
            :key="item"
        >
          <img
              :src="
              require('@/assets/images/projects/' + this.projectId + '/slider/' + item)
            "
              class="w-80 h-80"
              style="background: rgba(110, 117, 141, 0.2)"
              alt=""
          />
        </div>
      </template>
      <template v-slot:pagination>
        <div class="w-1.25 h-1.25 rounded-full bg-white"></div>
      </template>
    </slider>

    <p class="font-medium fz-16 mx-4.5 my-25" style="line-height: 1.875;">{{text.text[2]}}</p>

    <section class="content second-third px-4.5 mb-27.5">
      <p class="fz-22 mb-12.5" style="color: #f22959; line-height: 1.3636;">{{text.resultTitle}}</p>

      <div class="flex flex-col">
        <hr class="h-px w-full" style="border-color:rgba(151, 163, 203, 0.3);">
        <div class="flex flex-col mt-7.5" v-for="(item, index) in text.result" :key="index">
          <span class="uppercase font-medium fz-10 mb-2.5" style="letter-spacing: 0.1rem; color:rgba(110, 117, 141, 1) ">0{{ index + 1 }}</span>
          <p class="font-medium fz-16 w-90p mb-7.5" style="line-height: 1.875;">{{item}}</p>
          <hr class="h-px w-full" style="border-color:rgba(151, 163, 203, 0.3);">
        </div>
      </div>
    </section>

    <a href="#mobile-start" class="to-top flex flex-col mb-25 ml-19.5">
      <svg class="transform rotate-180 mb-2.5 w-3" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 6L7 12L13 6" stroke="rgba(151, 163, 203, 0.6)" stroke-linejoin="round"/>
        <path d="M6.99998 0V12" stroke="rgba(151, 163, 203, 0.6)" stroke-linejoin="round"/>
      </svg>
      <p class="uppercase font-medium fz-10" style="line-height: 1; color: rgba(151, 163, 203, 0.6); letter-spacing: 0.3rem">{{ text.back }}</p>
    </a>

<!--    <div class="next relative flex flex-col pt-10">-->
<!--      <img class="absolute top-0 bottom-0 left-0 right-0" style="z-index: -1;" :src="require('@/assets/images/projects/' + projectId + '/next-m.png')" alt="">-->
<!--      <p class="uppercase fz-13 mb-2.5 font-semibold ml-4.5" style="line-height: 1.5384;">{{text.next}}</p>-->
<!--      <h3 class="fz-22 ml-4.5" style="line-height: 1.3636; color: #f22959">{{text.nextTitle}}</h3>-->
<!--      <div class="relative flex ml-4.5 my-7">-->
<!--        <img-->
<!--            src="@/assets/images/eye-circle.svg"-->
<!--            class="w-12 h-12 cursor-pointer mr-5"-->
<!--            alt=""-->
<!--        />-->
<!--        <img-->
<!--            @click="changeSlide(currentSlide + 1)"-->
<!--            src="@/assets/images/arrow-down-circle.svg"-->
<!--            class="w-12 h-12 cursor-pointer"-->
<!--            alt=""-->
<!--        />-->
<!--      </div>-->
<!--      <div class="h-2" style="background:#f22959;"></div>-->
<!--    </div>-->
  </article>
</template>

<script>
import slider from "@/components/mobile/reuseable/slider";
import {mapMutations, mapState} from "vuex";


export default {
  name: "project",
  components:{
    slider
  },
  methods:{
    ...mapMutations(['setRoute'])
  },
  computed:{
    ...mapState(['lang', 'projectId']),
    text(){
      return {
        ...require("@/assets/text/projects/slide1/" + this.lang + ".json"),
        ...require("@/assets/text/project/" + this.lang + ".json").projects[this.projectId],
      };
    },
  }
}
</script>

<style scoped>
#app{
  height: auto!important;
}
</style>
